export var FlagType;
(function (FlagType) {
    FlagType["Good"] = "eGoodFlag";
    FlagType["Bad"] = "eBadFlag";
})(FlagType || (FlagType = {}));
